export default "__VITE_ASSET__BT9tADB4__"